import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";
import { ResponseMetaData } from "../../entities/global";
import { getRules, patchRule, postRule } from "./thunks";
import { IReqRules, Rule } from "../../entities/rules";

interface RulesState {
  rules: Rule[]
  rule?: Rule,
  loading: boolean,
  loadingError: boolean,
  saveLoading: boolean,
  meta: ResponseMetaData
}

const initialState: RulesState = {
  rules: [],
  loading: false,
  saveLoading: false,
  loadingError: false,
  meta: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  }
}

export const ruleSlice = createSlice({
  name: "rule",
  initialState,
  reducers: {
    onHandlerRule: (state: Draft<RulesState>, action: PayloadAction<Rule>) => {
      state.rule = action.payload;
    },
    onClearState: (state: Draft<RulesState>) => {
      state.rule = undefined;
    }
  },
  extraReducers: (builder) => {
    // getRules
    builder.addCase(getRules.pending, (state) => {
      state.loading = true;
    })
    builder.addCase(getRules.fulfilled, (state, action: PayloadAction<IReqRules>) => {
      const { data, ...meta } = action.payload;
      state.meta = meta;
      state.rules = data;
      state.loading = false;
    })
    builder.addCase(getRules.rejected, (state) => {
      state.loading = false;
    })
    // postRule
    builder.addCase(postRule.pending, (state) => {
      state.saveLoading = true;
    })
    builder.addCase(postRule.fulfilled, (state) => {
      state.saveLoading = false;
      state.rule = undefined;
    })
    builder.addCase(postRule.rejected, (state) => {
      state.saveLoading = false;
    })
    //patchRule
    builder.addCase(patchRule.pending, state => {
      state.saveLoading = true;
    })
    builder.addCase(patchRule.fulfilled, state => {
      state.saveLoading = false;
      state.rule = undefined;
    })
    builder.addCase(patchRule.rejected, state => {
      state.saveLoading = false;
    })
  },
});

export const { onHandlerRule, onClearState } = ruleSlice.actions;

export const selectRuleState = (state: RootState) => state.rule;

export default ruleSlice.reducer;
